import './QuizModal.css';

export default function QuizModal({ isOpen, onClose, children }) {
  if (!isOpen) return null;
  return (
    <div
      className="quiz-modal-overlay"
      onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}
    >
      {children}
    </div>
  );
}
